var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./report.beneficiary.constants";
export var usePaged = (_a = generateHooks(GENERATOR_PARAMS), _a.usePaged), useCount = _a.useCount;
